<template>
    <table v-if="headers.length" class="data-table-component mt-12 w-full" :class="loading === true ? 'opacity-40' : ''">
        <tr v-if="headers.length">
            <td v-for="(header, index) in headers" :key="index">
                {{ header }}
            </td>
        </tr>
        <tr v-if="!items.length">
            <td :colspan="headers.length">
                No items to display.
            </td>
        </tr>
        <tr v-else v-for="(item, index) in items" :key="index">
            <td v-for="(value, index) in item" :key="index">
                {{ value }}
            </td>
        </tr>
        <!-- <tr>
            <td>1234</td>
            <td class="!text-deep-blue font-semibold">Mr John Smith</td>
            <td>01 - 01 - 2023</td>
            <td>United Kingdom</td>
            <td><StatusBadgeComponent status="Submitted" /></td>
            <td><StatusBadgeComponent status="Approved" /></td>
        </tr>
        <tr>
            <td>1234</td>
            <td class="!text-deep-blue font-semibold">Mr John Smith</td>
            <td>01 - 01 - 2023</td>
            <td>United Kingdom</td>
            <td><StatusBadgeComponent status="Submitted" /></td>
            <td><StatusBadgeComponent status="Rejected" /></td>
        </tr>
            <tr>
            <td>1234</td>
            <td class="!text-deep-blue font-semibold">Mr John Smith</td>
            <td>01 - 01 - 2023</td>
            <td>United Kingdom</td>
            <td><StatusBadgeComponent status="Submitted" /></td>
            <td><StatusBadgeComponent status="First Approval" /></td>
        </tr> -->
    </table>
</template>

<script>
export default {
    name: "DataTableComponent",
    props: {
        status: { type: String, default: "" }, // Sets the "status" for the badge
        loading: { type: Boolean, default: false },
        headers: { type: Array, default: () => [] }, // Sets the headings/headers of the table
        items: { type: Array, default: () => [] } // The items to show within the table
    },
    components: {
    },
    computed: {},
    mounted(){
        // this.getStatus();
    },
    data: function () {
        return {
        };
    },
    methods: {
	}
};
</script>
